import React from 'react';
import { Button } from 'reactstrap';
import Table from 'components/Table';
import clsx from 'clsx';
import dayjs from 'dayjs';
import { moneyFormatter, moneyDecimalFormatter, getCargoType, customRound } from 'utli';
// import CheckBox from 'components/Inputs/CheckBox';

import { t } from 'i18next';

function List({
  headers,
  // selectedData = [],
  data,
  // onSelect,
  title,
  onToggle,
  buttons,
  filter, 
  showDetail,
  onPageChange,
  onChoose, 
  canEdit,  
  onEdit,
  canDelete,
  onDelete,
}) {
  return (
    <div className='address-table'>
      <h3>{title}</h3>
      <Table
        data={data}
        subtitle={t('sidebar.deposit_invoice')}
        filter={filter}
        onPageChange={onPageChange}
        headers={headers.map((e) => (
          <th
            className={clsx('headers', e.className)}
            key={`thead-${Math.random()}`}
            style={{ width: e.width, left: e.left, right: e.right }}
          >
            {t(e.text)}
          </th>
        ))}
        buttons={buttons}
        rows={data?.docs?.map((e, index) => (
          <tr key={`table-row-${index}-${Math.random()}`}>
        
            <td className='fixed-cell left'>
              <span style={{ cursor: 'pointer' }} onClick={() => showDetail(e)}>
                {e.invoice_number}
              </span>
            </td>
            <td>{dayjs(e.invoice_date).format('DD/MM/YYYY')}</td>
            <td>{e.address_code}</td>
            <td>{e.sender?.company}</td>
            <td>{e.sender?.name}</td>
            <td>{e.sender?.phone}</td>
            <td>{e.receiver?.company}</td>
            <td>{e.receiver?.name}</td>
            <td>{e.receiver?.phone}</td>
            <td>{e.destination?.name}</td>
            <td>{e.currency}</td>
            <td>{moneyDecimalFormatter(customRound(e.total_amount.toFixed(1)))}</td>  
            <td>{e?.sale_person?.name}</td>

            {!onChoose && (
              <td className='fixed-cell'>
         
                  <Button style={{ width: 30 }} size='sm' onClick={() => onEdit(e)} disabled={!canEdit()}>
                    <i className='fa fa-edit mr-2' />
                  </Button>
              
             
                  <Button
                    style={{ width: 30 }}
                    size='sm'
                    disabled={!canDelete()}
                    onClick={() => {
                      onDelete(e);
                    }}
                  >
                    <i className='fa fa-trash mr-2' />
                  </Button>
               
                <Button style={{ width: 30 }} size='sm' onClick={() => onToggle(e)}>
                  <i className='fa fa-print' aria-hidden='true'></i>
                </Button>
              </td>
            )}
            {onChoose && (
              <td className='fixed-cell'>
                <Button size='sm' color='success' onClick={() => onChoose(e)}>
                  <i className='fa fa-check-circle' />
                </Button>
              </td>
            )}
          </tr>
        ))}
        footer={
          <>
            <td>-</td>
            <td>{t('waybill_entry.total')}</td>
            <td colSpan={8}></td> 
            <td style={{ textAlign: 'right' }}>
              {' '}
              {moneyFormatter(customRound(data?.totalSum?.total_amount?.toFixed(2)))}
            </td>
          </>
        }
      />
    </div>
  );
}

export default List;
